import { AxiosError } from 'axios';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import {
  ICreateAreaRequest,
  ICreateAreaResponse,
} from '../../models/warehouse/createArea.model';
import useHttps from '../useHttps';

const useCreateArea = () => {
  const { warehouseId } = useParams();
  // console.log('warehouseId--->>', warehouseId);
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  useEffect(() => {}, []);

  const onUpdatePriceError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ?? 'Something went wrong while creating area'
    );
  };

  const onAreaSuccess = ({
    message,
  }: SuccessHttpResponse<ICreateAreaResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const createArea = (data: ICreateAreaRequest) => {
    // TODO:: Comback and fix this
    // const warehouseId = '';
    const url: HttpConfig = {
      url: `general-service/v1/prices/warehouse/${warehouseId}`,
      method: 'post',
      data,
    };

    request(url, onAreaSuccess, setLoading, onUpdatePriceError);
  };

  return { createArea, loading, resetInputFields };
};

export default useCreateArea;
